import React, { Component, Fragment } from 'react'
import ScrollToTop from 'react-scroll-up'

import Sections from './Sections'

import data from '../_main_data'

class App extends Component {
  render() {
    return (
      <Fragment>
        <Sections sections={data.sections} info={data.info} />
        <ScrollToTop showUnder={500}>
          <span className="scroll-up-btn"><i className="fas fa-angle-double-up"></i></span>
        </ScrollToTop>
      </Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js